var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector23(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 308,
    viewBox: "0 0 175 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328.374 307.495C304.986 288.58 301.279 284.461 286.463 265.052C282.833 260.298 277.121 251.054 271.666 239.636C270.031 236.219 268.549 232.831 267.19 229.49C257.496 205.583 256.127 178.8 258.38 152.349C264.129 84.8602 227.598 23.9482 172.287 6.19091C116.871 -11.6138 55.3542 17.6558 25.3323 63.316C21.4263 69.2573 4.19627 97.2931 1.6493 128.053C-6.41926 225.172 87.657 263.98 230.8 293.364C233.585 293.933 246.842 296.106 249.655 296.496L328.383 307.495H328.374Z",
    stroke: "#1E1E22",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector23);
export default __webpack_public_path__ + "static/media/vector2-3.fb29039209e98334db51727b04b46779.svg";
export { ForwardRef as ReactComponent };